skrilla.controller('bounceWithdrawalModalCtrl', function ($scope, cacheService, modalService, searchService, validationService) {
    $scope.withdrawal = cacheService.getObject("bounceWithdrawal");
    $scope.request = {};
    $scope.validate = {};
    $scope.create = function () {
        if(validateForm()) {
            modalService.confirm("Are you sure this successfully processed withdrawal bounced back," +
                " and you have checked with Finance that the funds are in the relevant bank account," +
                " and you require the funds re-deposited back into the clients available account? ", function () {
                searchService.put("withdrawals/" + $scope.withdrawal.id + "/refund", $scope.request, "Withdrawal successfully bounced").then(function (response) {
                    modalService.dismissAll();
                });
            });
        }
    }

    function validateForm(){
        var inputs = [
            validationService.buildFieldValidationObj("refundedAt", validationService.isNotEmpty($scope.request.refundedAt), "Please enter a refund date")
        ];
        return validationService.validateForm(inputs, $scope.validate)
    }

});
